// extracted by mini-css-extract-plugin
export var askAiIcon = "_kl-9";
export var container = "_kl-0";
export var groupSeparator = "_kl-a";
export var highlight = "_kl-4";
export var resultIcon = "_kl-5";
export var resultItem = "_kl-7";
export var resultSubtitle = "_kl-3";
export var resultTitle = "_kl-2";
export var resultsList = "_kl-1";
export var searchGroup = "_kl-6";
export var selected = "_kl-8";